/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leavestay1Inputs */

const en_leavestay1 = /** @type {(inputs: Leavestay1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay`)
};

const de_leavestay1 = /** @type {(inputs: Leavestay1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleiben`)
};

/**
* | output |
* | --- |
* | "Stay" |
*
* @param {Leavestay1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const leavestay1 = /** @type {((inputs?: Leavestay1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leavestay1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leavestay1(inputs)
	return de_leavestay1(inputs)
});
export { leavestay1 as "leaveStay" }